import { AnimatePresence, motion } from 'framer-motion';
import useCountdown from '../../hooks/useCountdown';
import useWSTurnState, { TURN_PHASES } from '../../hooks/useWSTurnState';

export default function NextIn({
  label = "Next in...",
  size = 1.5
}) {
  const { currentPhase, autoAdvanceIn, autoAdvanceInTimestamp } = useWSTurnState();

  // Mostra quando está em A_COMPLETING ou B_COMPLETING e tem autoAdvanceIn
  const shouldShow = (currentPhase === TURN_PHASES.ACompleting || currentPhase === TURN_PHASES.BCompleting) && autoAdvanceIn != null;

  // Usa hook de countdown baseado em timestamp da mensagem recebida
  const seconds = useCountdown(autoAdvanceIn, shouldShow, null, autoAdvanceInTimestamp);

  // Cor da bolinha muda quando seconds <= 10
  const isLowTime = seconds <= 10;
  const ballBackgroundColor = isLowTime ? "#FDBE2D" : "#FAF6EC";
  const ballTextColor = isLowTime ? "white" : "#333";

  // valores relativos baseados no tamanho
  const baseHeight = 40 * size;
  const fontSize = 16 * size;
  const pillPaddingY = 6 * size;
  const pillPaddingX = 18 * size;
  const gap = 8 * size;

  if (!shouldShow) return null;

  return (
    <div style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', zIndex: 10 }}>
      <AnimatePresence>
        {shouldShow && (
          <motion.div
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            exit={{ y: -100 }}
            transition={{ duration: 0.4, delay: 0.2 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: `${gap}px`,
                width: "fit-content",
              }}
            >
              {/* pill branca */}
              <div
                style={{
                  backgroundColor: "#FAF6EC",
                  color: "#333",
                  borderRadius: "9999px",
                  padding: `${pillPaddingY}px ${pillPaddingX * 2}px ${pillPaddingY}px ${pillPaddingX}px`,
                  fontSize: `${14 * size}px`,
                  fontWeight: 500,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  lineHeight: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {label}
              </div>

              {/* bolinha amarela encaixada */}
              <div
                style={{
                  marginLeft: `${-baseHeight * 0.9}px`,
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    backgroundColor: ballBackgroundColor,
                    color: ballTextColor,
                    fontWeight: "bold",
                    fontSize: `${fontSize}px`,
                    width: `${baseHeight}px`,
                    height: `${baseHeight}px`,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                  }}
                >
                  {seconds}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

